import React, { useState } from "react";
import { FormLabel } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import SearchableSelect from "../Forms/SearchableSelect";
import { useTranslation } from "react-i18next";
import { styles } from "./styles";

const RequestAgeFilter = (props) => {
  const [requestAge, setRequestAge] = useState();
  const { t } = useTranslation();
  const { classes, onSearchCriteriaChange } = props;
  const options = [
    { value: 15, label: t("labels.filter.last15Days") },
    { value: 30, label: t("labels.filter.last30Days") },
  ];

  const handleAgeChange = async (v) => {
    setRequestAge(v);
    if (onSearchCriteriaChange) {
      onSearchCriteriaChange({ requestAge: v ? v.value : null });
    }
  };

  return (
    <div className={classes.filterContainer}>
      <FormLabel className={classes.headerLabel}>{t("labels.filter.byRequestAge")}</FormLabel>
      <SearchableSelect
        options={options}
        value={requestAge}
        changeHandler={handleAgeChange}
        placeholder={""}
      />
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(RequestAgeFilter);
